import React from 'react';
import styled from 'styled-components';
import { PageSlice } from '@contracts';
import ImageSlider from '../shared/ImageSlider';
import Text from './Text';

interface Props {
  slice: PageSlice;
}

const ImageSliderSlice: React.FC<Props> = ({ slice }) => {
  const backgroundColor = slice.primary?.background_color;
  const backgroundGradient = slice.primary?.background_gradient.text;
  const arrows = slice.primary?.arrows;
  const pagination = slice.primary?.pagination;
  const maxWidth = slice.primary?.max_width.text ?? '100%';
  const textColor = slice.primary?.text_color;

  return (
    <Container $backgroundColor={backgroundColor} $backgroundGradient={backgroundGradient}>
      <Text richText={slice.primary?.title.richText} textColor={textColor} />
      <div style={{ height: 30 }} />
      <ImageSlider slides={slice.items} arrows={arrows} pagination={pagination} maxWidth={maxWidth} />
    </Container>
  );
};

export default ImageSliderSlice;

interface StyleProps {
  $backgroundColor?: string;
  $backgroundGradient?: string;
  $breakpoint?: string;
  $padding?: string;
  $background?: string;
  $textColor?: string;
  $imageWidth: string;
  $textWidth: string;
}

const Container = styled.div<StyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${(props) => props.$backgroundColor};
  background-image: ${(props) => (props.$backgroundGradient ? props.$backgroundGradient : 'none')};
  padding: 90px 30px;

  @media (max-width: 1024px) {
    padding: 40px 20px;
  }
`;
